import { render, staticRenderFns } from "./FileTemplate.vue?vue&type=template&id=ce96a0c4&scoped=true"
import script from "./FileTemplate.vue?vue&type=script&lang=js"
export * from "./FileTemplate.vue?vue&type=script&lang=js"
import style0 from "./FileTemplate.vue?vue&type=style&index=0&id=ce96a0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce96a0c4",
  null
  
)

export default component.exports